import { useContext } from 'react'

import { FormStateContext } from '../DisplayForm'

export const useDisplayFormState = () => useContext(FormStateContext)
